import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloMuroCarbonDeBambu from '../components/sections/MuroCarbonDeBambu/TituloMuroCarbonDeBambu'; 
import IntroMuroCarbonDeBambu from '../components/sections/MuroCarbonDeBambu/IntroMuroCarbonDeBambu'; 
import InfoMuroCarbonDeBambu from '../components/sections/MuroCarbonDeBambu/InfoMuroCarbonDeBambu';  
// import CatalogoMuroCarbonDeBambu from '../components/sections/MuroCarbonDeBambu/CatalogoMuroCarbonDeBambu'; 
import FormularioContactoCarbonBambu from '../components/sections/MuroCarbonDeBambu/FormularioContactoCarbonBambu'; 
import Header from '../components/layouts/Header'; 
import Footer from '../components/layouts/Footer';

const MuroCarbonDeBambu = () => {
  return (
    <div>
      <SeoMetadata
        title="Muro de Carbón de Bambú | Decototal"
        description="Explora los paneles de carbón de bambú para renovar y decorar interiores. Conoce sus características y pide una cotización en Decototal."
        keywords="muro de carbón de bambú, panel de bambú, revestimiento de muros, decoración de interiores"
        path="/muro-carbon-de-bambu"
        image="/assets/img/home/muro-carbon-bambu-titulo.jpg"
      />
      <Header />
        <TituloMuroCarbonDeBambu />   
        <IntroMuroCarbonDeBambu />  
        <InfoMuroCarbonDeBambu />  
        {/* <CatalogoMuroCarbonDeBambu />    */}
        <FormularioContactoCarbonBambu /> 
      <Footer />
    </div>
  );
};

export default MuroCarbonDeBambu;
